import useMainSnackbarStore from '~/stores/useMainSnackbarStore';
export default defineNuxtRouteMiddleware(function () {
  var $snackbar = useMainSnackbarStore();
  if (!$snackbar.isActive) {
    return;
  }
  if ($snackbar.dontCloseOnRouteChange) {
    $snackbar.dontCloseOnRouteChange = false;
  } else {
    $snackbar.close();
  }
});